module.exports = __webpack_public_path__ + "workspace/static/img/psaTwo.b9cdcb4.png";